import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { TicketsView } from "./tickets-view";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import "./tickets.scss";
export const TicketsController = (props) => {
	const [results, setResults] = useState([]);
	const [submitAns, setSubmitAns] = useState(0);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		props.handleExpandFal();
		const search = async () => {
			const apiUrl = `/ticket?param=mytickets&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl,true, {});
			setResults(data);
		};
		search();
	}, [submitAns]);

	

	if (results.length) {
				
		return (
			<>
				<Helmet>
					<title>Support Center | SmarterChains</title>
					<meta name="description" content="Support Center" />
				</Helmet>
				<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
				<BreadcrumbsItem to="#">Support Center</BreadcrumbsItem>
				<TicketsView ticketData={results} onSubmitAns={setSubmitAns} {...props} />
			</>
		);


	}else{
					return (
					<>
						<div></div>
					</>
				);
		}
};
